import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
  import { gsap } from 'gsap';
  import { setCookie, getCookie } from '../services/cookieService';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Animations',
  setup(__props) {

  const animationWrapper = ref<HTMLElement | null>(null);

  onMounted(() => {
    if (getCookie('seenHeroAnimation') !== 'true') {
      handleHeroAnimation();
    }
  });

  function handleHeroAnimation() {
    const tl = gsap.timeline({
      defaults: { duration: 0.8, ease: 'power2.out' },
      onComplete: () => {
        setCookie('seenHeroAnimation', 'true', 1);
      },
    });

    const children = animationWrapper.value?.children || [];
    
    tl.from([...children],
      {
        y: 100,
        opacity: 0,
        stagger: 0.2,
      }
    )
   
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "animationWrapper",
    ref: animationWrapper,
    class: "hero-animation-wrapper"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})